import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { Typography } from '@material-ui/core';

export function VersionFooter() {
  const config = useApi(configApiRef);
  const version = config.getOptionalString('app.version') ?? 'dev';

  return (
    <Typography
      variant="caption"
      style={{
        display: 'block',
        textAlign: 'center',
        padding: '8px 0',
        opacity: 0.5,
        fontSize: 10,
      }}
    >
      {version}
    </Typography>
  );
}
